import { render } from "./AppHeader.vue?vue&type=template&id=4b6f8280&bindings={}"
import script from "./AppHeader.vue?vue&type=script&lang=ts"
export * from "./AppHeader.vue?vue&type=script&lang=ts"

import "./AppHeader.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script